import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from '../service/data.service';

@Component({
  selector: 'app-import-form',
  templateUrl: './import-form.component.html',
  styleUrls: ['./import-form.component.less']
})
export class ImportFormComponent implements OnInit {

  currentJsonImport:any;

  constructor(public importDialog: MatDialog, public data:DataService) { }

  ngOnInit(): void {

    this.currentJsonImport = JSON.stringify(this.data.editor, null, 2);
  }


  closeDialog(){
    this.importDialog.closeAll();
  }

  okDialog(){
    var editorImportData = JSON.parse(this.currentJsonImport);

    this.data.editor.Controls = editorImportData.Controls;

  
    this.data.save();
    this.importDialog.closeAll();
  }

}
